import React from "react";
import { Entity } from "../../data/companies";

import companyLogo from "../../images/logo/company-logo.png";

// ============================================================
// "Why {Company}?" — Our Capabilities
// ORIGINAL KOT FeatureSection design: left 3 cards (text-end) +
// center AERIS + right 3 cards; baqi capabilities neeche row me.
// Content: entity.capabilities — warna purpose fallback.
// ============================================================
const CompanyFeatures: React.FC<{ entity: Entity }> = ({ entity }) => {
  const cards =
    entity.capabilities ??
    entity.purpose.map((p) => ({ title: p, desc: "" }));

  const left = cards.slice(0, 3);
  const right = cards.slice(3, 6);
  const rest = cards.slice(6);

  return (
    <section className="feature pt-145 pb-80">
      <div className="container">
        <div className="sec-title sec-title-center fea-sec-title text-center mb-50">
          <h2 className="title">{entity.capabilitiesTitle ?? "Our Capabilities"}</h2>
        </div>

        <div className="row mt-none-30 align-items-center">
          {/* Left cards (text-end) */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-left-item">
              {left.map((card, i) => (
                <div
                  className="xb-feature-item xb-feature-item2 wow fadeInUp"
                  data-wow-delay={`${100 + i * 100}ms`}
                  data-wow-duration="600ms"
                  key={card.title}
                >
                  <div className="xb-item--inner justify-content-end xb-border xb-cap-card">
                    <div className="xb-item--holder text-end">
                      <h2 className="xb-item--title text-end">{card.title}</h2>
                      {card.desc && (
                        <p className="xb-item--content text-end mb-0">
                          {card.desc}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right cards */}
          <div className="col-lg-4 col-md-6 order-lg-last mt-30">
            <div className="xb-feature-right-item">
              {right.map((card, i) => (
                <div
                  className="xb-feature-item xb-feature-item2 xb-border wow fadeInUp"
                  data-wow-delay={`${100 + i * 100}ms`}
                  data-wow-duration="600ms"
                  key={card.title}
                >
                  <div className="xb-item--inner xb-border xb-cap-card">
                    <div className="xb-item--holder">
                      <h2 className="xb-item--title">{card.title}</h2>
                      {card.desc && (
                        <p className="xb-item--content mb-0">{card.desc}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Center — AERIS */}
          <div className="col-lg-4 col-md-12 mt-30">
            <div
              className="xb-feature-img pos-rel text-center wow zoomIn"
              data-wow-delay="0ms"
              data-wow-duration="600ms"
            >
              <img
                src={companyLogo}
                alt={entity.name}
                style={{ maxWidth: "100%", height: "auto" }}
                className="updown"
              />
            </div>
          </div>
        </div>

        {/* Baqi capabilities — neeche same style row */}
        {rest.length > 0 && (
          <div className="row mt-10 justify-content-center">
            {rest.map((card, i) => (
              <div className="col-lg-4 col-md-6 mt-30" key={card.title}>
                <div
                  className="xb-feature-item xb-feature-item2 wow fadeInUp h-100"
                  data-wow-delay={`${100 + i * 100}ms`}
                  data-wow-duration="600ms"
                >
                  <div className="xb-item--inner xb-border xb-cap-card" style={{ height: "100%" }}>
                    <div className="xb-item--holder">
                      <h2 className="xb-item--title">{card.title}</h2>
                      {card.desc && (
                        <p className="xb-item--content mb-0">{card.desc}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CompanyFeatures;
